import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function PayrollPage() {
  return <InstituteCrudPage config={entityConfigs['payroll']} />;
}
